<template>
    <information-modal
        title="Filter Options"
        v-model="model"
        :show-footer="true"
        width="50.5em"
        modal-body-container-class="overflow-visible-y">
        <template #body>
            <div class="container-fluid">                
                
                <b-filter-editor
                v-model="filterInfo"
                    ref="filterEditor"
                    :value="filterInfo"
                    :fields="filterableFields"
                    @add-filter="addFilter"
                    @remove-filter="removeFilter"
                    @update-filter="updateFilter"></b-filter-editor>
            </div>
        </template>
        <template #footer>
            <div class="row mt-2">
                <div class="col-sm-12">
                    <div class="hstack gap-2 align-end">
                      
                        <button
                            type="button"
                            class="btn btn-primary"
                            :class="{disabled: isApplyFilterDisabled}"
                            :disabled="isApplyFilterDisabled"
                            :aria-disabled="isApplyFilterDisabled"
                            @click.prevent="applyFilters">
                            Apply Filter
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            :class="{disabled: !hasAppliedFilters}"
                            :disabled="!hasAppliedFilters"
                            :aria-disabled="!hasAppliedFilters"
                            @click.prevent="resetFilters">
                            Clear Filter
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </information-modal>
</template>
<script setup lang="ts">
import {computed, ref, watch} from "vue";
import BFilterEditor from "./BFilterEditor.vue";
import {BFilter, BFilterOptions, BFilterableField, describeFilters} from "./BFilterEditor.types";
import {deepCopy} from "@/utils";
import InformationModal from "../Misc/InformationModal.vue";

const model = defineModel({type: Boolean});

const props = withDefaults(
    defineProps<{
        filterOptions: BFilterOptions;
        filterableFields: BFilterableField[];
    }>(),
    {
        filterOptions: () =>
            ({
                filters: [],
            } as BFilterOptions),
        filterableFields: () => [],
    }
);

const emit = defineEmits<{
    (e: "filterChanged", filterInfo: BFilterOptions): void;
}>();


const isApplyFilterDisabled = computed(() => {
     return !filterInfo.value.filters.every(
        (it) => it.property != null && it.operation != null && it.value && it.property != "id"
    );
});
const hasAppliedFilters = computed(() => filterInfo.value.filters.length > 0);


var filterInfo = ref(deepCopy<BFilterOptions>(props.filterOptions));

const handleDataChange = (value: BFilterOptions) => {
    filterInfo.value = value;
};

watch(model, (newValue) => {
    if (newValue === true) {
        filterInfo.value = deepCopy<BFilterOptions>(props.filterOptions);
    }
});

watch(
    () => props.filterOptions,
    (newfilterOptions, prevFilterOptions) => {
        if (filterInfo.value != props.filterOptions) {
            filterInfo.value = props.filterOptions
                ? deepCopy<BFilterOptions>(props.filterOptions)
                : ({filters: {}} as BFilterOptions);                
        }
    }
);
function resetFilters() {
    filterInfo.value.filters = [];
    emit("filterChanged", filterInfo.value);
}

function applyFilters() {    
    emit("filterChanged", filterInfo.value);
}

function addFilter() {
    var newFilter = {
        property: null,
        operation: null,
        value: null,
    } as BFilter;

    if (filterInfo.value) {
        filterInfo.value.filters = [...filterInfo.value.filters, newFilter];
    }
}

function removeFilter(index: number) {
    if (filterInfo.value) {
        filterInfo.value.filters = filterInfo.value.filters.filter((it: any, ix: number) => ix != index);
    }
}

function updateFilter(data: any) {
    if (data?.index > 0 && data?.filter != undefined) {
        filterInfo.value.filters[data.index] = data.filter;
    }   
}
</script>
<style lang="css">
.overflow-visible-y {
    overflow-y: visible !important;
}
</style>
